import { SHOPPING_LISTS_ENDPOINTS } from "./endpoints";
import type { ShoppingList, SupermarketCode } from "./types";
import { apiRequestWithData } from "../shared";

function buildGetListUrl(weekStart?: string, supermarketCode?: SupermarketCode): string {
  const timestamp = Date.now();
  const params = new URLSearchParams();
  if (weekStart) params.append("week_start", weekStart);
  if (supermarketCode) params.append("supermarket_code", supermarketCode);
  params.append("_t", timestamp.toString());
  return `${SHOPPING_LISTS_ENDPOINTS.GET_CURRENT}?${params.toString()}`;
}

export async function getCurrentShoppingList(weekStart?: string, supermarketCode?: SupermarketCode): Promise<ShoppingList> {
  const url = buildGetListUrl(weekStart, supermarketCode);
  return apiRequestWithData<ShoppingList>(url, {
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
}

export default getCurrentShoppingList;
